import { api } from 'api';
import { requestErrorAction } from 'common/utils/requestErrorHandling';
import { ProviderOutstanding, ProviderSummary } from './actions';

export interface ProviderOutstandingsParams {
  group_system?: number;
  group_account?: number;
  group_stream?: number;
}

// #region ProviderOutstanding
export const requestProviderOutstandings = async (
  params?: ProviderOutstandingsParams
) =>
  await api.get<ProviderOutstanding[]>('/weekops/provider/outstanding/', {
    params,
  });

export const doGetProviderOutstandings =
  (params?: ProviderOutstandingsParams) => async (dispatch) => {
    dispatch({ type: 'providerOutstandings/started' });

    try {
      const response = await requestProviderOutstandings(params);

      dispatch({
        type: 'providerOutstandings/finished',
        providerOutstandings: response.data,
      });
    } catch (e) {
      dispatch(
        requestErrorAction(
          { type: 'providerOutstandings/finished' },
          e,
          `Failed to get provider outstandings.`
        )
      );
    }
  };
// #endregion

// #region ProviderSummary
export interface ProviderSummaryParams {
  end_date?: string;
}

export const requestProviderSummaries = async (params: ProviderSummaryParams) =>
  await api.get<ProviderSummary[]>('/providers_summary/', { params });

export const doGetProviderSummaries =
  (params: ProviderSummaryParams) => async (dispatch) => {
    dispatch({ type: 'providerSummaries/started' });

    try {
      const response = await requestProviderSummaries(params);

      dispatch({
        type: 'providerSummaries/finished',
        summaries: response.data,
      });
    } catch (e) {
      dispatch(
        requestErrorAction(
          { type: 'providerSummaries/finished' },
          e,
          `Failed to get provider summaries.`
        )
      );
    }
  };
// #endregion
